"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokerDealerAuthorizations = void 0;
exports.BrokerDealerAuthorizations = {
    TRANSFER_AGENT: 'transfer-agent',
    AUDIT_LOG_ISSUER: 'audit-log-issuer',
    ALLOW_EXPORT: 'allow-export',
};
//# sourceMappingURL=broker-dealer-group.js.map